import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';

export function trackListingClose(jsonQuery: IJsonQuery, queryString: string) {
  ca('eventSite', {
    event: 'oldevent',
    name: 'oldevent',
    category: 'Listing',
    action: 'click_sopr',
    label: 'close_listing',
    page: {
      pageType: 'Map',
      // Когда мкс отображается на ЧПУ ссылке queryString можно получить только из стейта
      queryString: window.location.search || queryString,
    },
    sc: jsonQuery,
  });
}
